<mat-tab-group (selectedTabChange)="tabClicked($event)" [(selectedIndex)]="ActiveTab" mat-stretch-tabs class="tab_group">
    <mat-tab label="Permission" class="tab_content" *ngIf="persistenceService.get('addDisable') == 'true'">
        <div class="view_div" *ngIf="viewDataAvail">
            <mat-card appearance="outlined" class="view_card">
                <table mat-table [dataSource]="appointmentForEmpList" class="mat-elevation-z8">
                    <ng-container matColumnDef="visitor_name">
                        <th mat-header-cell *matHeaderCellDef>Name</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_name}} </td>
                    </ng-container>
                    <ng-container matColumnDef="visitor_company">
                        <th mat-header-cell *matHeaderCellDef>Company</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_company}} </td>
                    </ng-container>
                    <ng-container matColumnDef="visitor_mobile_no">
                        <th mat-header-cell *matHeaderCellDef>Mobile No</th>
                        <td mat-cell *matCellDef="let element"> {{element.visitor_mobile_no}} </td>
                    </ng-container>
                    <ng-container matColumnDef="address">
                        <th mat-header-cell *matHeaderCellDef>Address</th>
                        <td mat-cell *matCellDef="let element"> {{element.address}},{{element.city}},{{element.state}} </td>
                    </ng-container>
                    <ng-container matColumnDef="appointment_type">
                        <th mat-header-cell *matHeaderCellDef>Type</th>
                        <td mat-cell *matCellDef="let element"> {{element.appointment_type}} </td>
                    </ng-container>
                    <ng-container matColumnDef="purpose">
                        <th mat-header-cell *matHeaderCellDef>Purpose</th>
                        <td mat-cell *matCellDef="let element"> {{element.purpose}} </td>
                    </ng-container>
                    <ng-container matColumnDef="schedule_date_from">
                        <th mat-header-cell *matHeaderCellDef>Date & Time</th>
                        <td mat-cell *matCellDef="let element"> {{element.schedule_date_from}}/{{element.schedule_time_from}} </td>
                    </ng-container>


                    <ng-container matColumnDef="permission">
                        <th mat-header-cell *matHeaderCellDef> Permission </th>
                        <td mat-cell *matCellDef="let element">
                            <form class="global-form">
                                <table>
                                    <tr>
                                        <td>
                                            <mat-form-field appearance="fill"  class="field-full-width">
                                                
<mat-label>Message</mat-label>
<input class="global-input" matInput required />
                                            </mat-form-field>
                                        </td>
                                        <td>
                                            <mat-form-field appearance="fill"  id="selectOption">
                                                
<mat-label>Permission</mat-label>
<mat-select>
                                                    <mat-option *ngFor="let perm of permissionYesNo" [value]="perm">
                                                        {{perm}}</mat-option>
                                                </mat-select>
                                            </mat-form-field>



                                        </td>
                                    </tr>
                                </table>
                            </form>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="viewatableColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: viewatableColumns;"></tr>


                </table>
            </mat-card>
        </div>
    </mat-tab>
    <mat-tab label="View Appointment" class="tab_content" *ngIf="persistenceService.get('viewDisable') == 'true'">

    </mat-tab>
</mat-tab-group>